import { IGetCustomerRate } from "../../models/response/ICustomerResponse";

export const getInvoiceDetailtListState: IGetCustomerRate = {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
    CustomerRate: []
}